import { Container, Wrapper } from './BreadCrumbStyles';
import right from '@/assets/right_small.svg';

const BreadCrumb = ({ list = [] }) => {
  return (
    <Container>
      {list.map((el, i) => (
        <Wrapper key={i}>
          <div className="text-text-300 text-xs">{el}</div>
          {i < list.length - 1 ? <img src={right} alt="right" /> : null}
        </Wrapper>
      ))}
    </Container>
  );
};

export default BreadCrumb;
